import Main from '../../views/main'
import {ParentView} from '@/ladmin'

export default [
  {
    path: '/passControl',
    name: 'passControl',
    component: Main,
    meta: {
      disabled: true,
      label: '通行管控'
    },
    children: [
      {
        name: 'blackList',
        path: 'blackList',
        component: () => import( '@/views/PassControl/blackList'),
        meta: {
          label: '冻结车牌管理'
        },

      },
      {
        name: 'blackListParent',
        path: 'blackListParent',
        component:ParentView,
        redirect:{name:'blackList'},
        meta: {
          label: '冻结车牌管理'
        },
        children: [
          {
            name: 'blackVehicle',
            path: 'blackVehicle',
            component:() => import(/* webpackChunkName: "pass" */ '@/views/PassControl/blackVehicle'),
            props: true,
            meta: {
              label: '添加冻结车牌'
            }
          }
        ]
      },
      {
        path: 'simulate',
        name: 'Simulate',
        meta: {
          label: '通行模拟'
        },
        component: () => import('@/views/PassControl/Simulate')
      },
      {
        path: 'passGroupList',
        name: 'passGroupList',
        meta: {
          label: '通行分组'
        },
        component: () => import('@/views/PassControl/passGroupList')
      },
      {
        path: 'passGroupListParent',
        name: 'passGroupListParent',
        redirect: {name: 'passGroupList'},
        meta: {
          label: '通行分组'
        },
        component: ParentView,
        children: [
          {
            path: 'newPassGroup',
            name: 'NewPassGroup',
            meta: {
              label: '新建通行分组'
            },
            component: () => import('@/views/PassControl/passGroupForm')
          }
        ]
      },
      {
        path: 'iotControl',
        name: 'iotControl',
        meta: {
          label: '硬件消息管理'
        },
        component: () => import('@/views/PassControl/Iot/groupList')
      },
      {
        path:'aloneVehicleList',
        name:'aloneVehicleList',
        meta: {
          label: '独立车辆'
        },
        component: () => import('@/views/PassControl/PassRule/vehicleList')
      },
      {
        path: 'vehicleRuleDetails',
        name: 'vehicleRuleDetailsBox',
        meta: {
          label: '车辆通行规则'
        },
        component: () => import('@/views/PassControl/PassRule/vehicleRuleDetailsBox')
      },
      {
        path:'aloneRuleList',
        name:'aloneRuleList',
        meta: {
          label: '独立规则'
        },
        component: () => import('@/views/PassControl/PassRule/passRuleList')
      },
      {
        path: 'centerAreaVehicle',
        name: 'centerAreaVehicle',
        meta: {
          label: '限定性区域车辆管理'
        },
        component: () => import('@/views/PassControl/centerArea')
      }
    ]
  }
]
